import clsx from 'clsx';
import { useState } from 'react';
import { ConfirmDialog } from '../ConfirmDialog';
import ImageEditor from '../image-editor';
import ImageLightbox from '../image-lightbox';
import ImageItem from './components/ImageItem';
import './style.scss';
import { ImageActionType, ImageItemProps, ImageListProps } from './types';


const ImageList = ({
	data,
	className,
	setData,
	onImageCrop,
	onImageDelete,
	...props
}: ImageListProps) => {
	const [actionActive, setActionActive] = useState<{
		open: boolean;
		data: ImageItemProps | null;
		action: ImageActionType;
	}>({
		action: 'view',
		open: false,
		data: null,
	});

	const onCrop = (base64Value: string) => {
		onImageCrop?.(base64Value, actionActive.data?.index!);
		resetSelected();
	};

	const onDelete = () => {
		onImageDelete?.(actionActive.data);
		resetSelected();
	};

	const resetSelected = () => {
		setActionActive({ open: false, data: null, action: 'view' });
	};

	const onImageActionClick = (action: ImageActionType, image: any) => {
		setActionActive({
			action,
			data: image,
			open: true,
		});
	};

	return (
		<div className={clsx('spaces w-100', className)} {...props}>
			{!!data.length &&
				data.map((image: ImageItemProps) => (
					<ImageItem
						key={image.index}
						index={image.index}
						title={image.title}
						onActionClick={onImageActionClick}
						{...image}
					/>
				))}

			{actionActive.action === 'crop' && actionActive.open && (
				<ImageEditor
					open={actionActive.open}
					onClose={resetSelected}
					onSave={(result: string) => {
						onCrop(result);
					}}
					src={actionActive.data!.src}
				/>
			)}

			{actionActive.action === 'view' && actionActive.open && (
				<ImageLightbox
					open={actionActive.open}
					onClose={resetSelected}
					images={data.filter((image) => !image.deleted)}
					indexActive={actionActive.data?.index}
				/>
			)}

			{actionActive.action === 'delete' && actionActive.open && (
				<ConfirmDialog
					className="z-index-1060"
					show={actionActive.open}
					title="Thông báo"
					message="Bạn có chắc chắn muốn xóa ảnh này không ?"
					yes="Xác nhận"
					close="Đóng"
					onCloseClick={() => {
						resetSelected();
					}}
					onYesClick={onDelete}
				/>
			)}
		</div>
	);
};

export default ImageList;
